import { Benefit } from "@/components/how-we-work";
import { siteSettings } from "@workspace/utils";

export const heroConfig = {
    headline: `MBA & Masters Admissions Consulting | Get Into Harvard, Stanford, INSEAD with Expert Guidance`,
    headlineForDisplay: `Smarter admits, Stronger community. Craft your global future with ${siteSettings.siteName}`,
    subheading: `Brew your best — Ethically, Globally, Intellectually<br/><br/><strong>Confused by rankings, endless advice, and cookie-cutter paths?</strong><br/>
    ${siteSettings.siteName} blends ethical admissions consulting with a powerful peer community- to help you get into top global universities and succeed in today’s competitive global job market.`,
    mainHeaderImage: {
        image: "/Homepage_headerimg1.png",
        alt: "GradBrew Dashboard preview",
        className: "hero_main-image",
    },
    subHeaderImage: {
        image: "/Homepage_headerimg3.png",
        alt: "Admit success",
        className: "home_header_image2",
    },
    logos: [
        {
            src: "/Homepage_headerimg_Harvard_University logo.png",
            alt: "Harvard University",
        },
        {
            src: "/Homepage_headerimg_Stanford logo.png",
            alt: "Stanford University",
        },
        {
            src: "/Homepage_headerimg_ISB logo.png",
            alt: "Indian School of Business",
        },
        {
            src: "/Homepage_headerimg_HEC_Paris logo.png",
            alt: "HEC Paris",
        },
        {
            src: "/Homepage_headerimg_Insead logo.webp",
            alt: "INSEAD Business School",
        },
        {
            src: "/Homepage_headerimg_LBS logo.jpg",
            alt: "London Business School",
        },
        {
            src: "/Homepage_headerimg_LSE logo.png",
            alt: "London School of Economics and Political Science",
        },
        {
            src: "/Homepage_headerimg_MIT logo.png",
            alt: "Massachusetts Institute of Technology",
        },
        {
            src: "/National_University_of_Singapore_Logo_og.png",
            alt: "National University of Singapore",
        },
        {
            src: "/Homepage_headerimg ESCP logo.png",
            alt: "ESCP Business School",
        },
        {
            src: "/University_of_Princeton_logo_og.png",
            alt: "University of Princeton",
        },
        {
            src: "/University_of_Cambridge_logo_og.png",
            alt: "University of Cambridge",
        },
        // Add more unique logos as needed
    ],
};

export const featuresConfig = {
    headline: `Why choose ${siteSettings.siteName} for your admissions journey?`,
    headlineCss: `text-[var(--primary--burgundy)] dark:text-[var(--primary--pink)]`,
    subheading: `${siteSettings.siteName} is more than consulting — it's your route to the world’s top campuses.
    Work one-to-one with elite alumni, follow a data-driven process, and keep your story 100 % ethical.<br/> The result? Admits and scholarships worldwide. <br/> The right balance of <strong>Strategy</strong> + <strong>Ethics</strong> + <strong>Outcomes</strong>`,
    featureList: [
        {
            img: {
                src: "/Homepage_dualconfeedback.png",
                alt: "Dual Consultant Feedback Two mentors. One perfected application",
                className: "feature-card_image left-align",
            },
            title: "Dual Consultant Feedback <br/> <i class='text-size-small'>Two mentors, One perfected application</i>",
            description: "Your Lead Consultant from your target school guides every draft.<br/> A second top-school Expert then steps in for a final, no-blind-spots review before you hit submit.<br/> Two sets of eyes—zero weak links.",
            link: {
                href: "",
                text: "Learn more",
            },
        },
        {
            img: {
                src: "/Homepage_ethical guidance.png",
                alt: "Ethical, Human-First Guidance. We don’t ghostwrite. We guide. You write. Authentically",
                className: "feature-card_image",
            },
            title: "Ethical, Human-First Guidance<br/> <i class='text-size-small'>We guide. You write. Authentically</i>",
            description: "Your story stays yours. Top-school mentors + smart AI refine it— NO ghostwriting, NO gimmicks.<br/> Transparent coaching that lets admissions hear the REAL YOU.",
            link: {
                href: "",
                text: "Our ethical promise",
            },
        },
        {
            img: {
                src: "/Homepage_end2endsupport.png",
                alt: "End-to-End Consulting from dream school to admit — step by step.",
                className: "feature-card_image left-align",
            },
            title: "End-to-End Support<br/> <i class='text-size-small'>From shortlist to admit — step by step</i>",
            description: "CVs, Essay / SOPs, mock interviews, school shortlists, deadlines — every moving part handled in one dashboard-driven workflow.<br/> We’re beside you at every milestone, so nothing slips through the cracks",
            link: {
                href: "",
                text: "Explore full process",
            },
        },
        {
            img: {
                src: "/Homepage_Rightcountry.png",
                alt: "Country-Specific Insights, not just top schools — the right ones.",
                className: "feature-card_image",
            },
            title: "Right Country, Right School<br/> <i class='text-size-small'>Insights beyond rankings</i>",
            description: "Get school shortlists tailored to local job markets, visa paths, cultural fit, and ROI — so your degree pays off where you land.<br/> Dive into our country playbooks to compare markets before you apply.",
            link: {
                href: "",
                text: "Explore country playbooks",
            },
        },
        {
            img: {
                src: "/Homepage_post admit support.png",
                alt: "Post-Admit Support Visa, Housing, Arrival, etc.guidance covered.",
                className: "feature-card_image left-align",
            },
            title: "Post-Admit Support<br/> <i class='text-size-small'>Guidance on Visa, housing, culture, etc.</i>",
            description: "Once you get in, we stay in to provide guidance only on relocation, finance, and life abroad.<br/> Visas, housing, banking, pre-departure prep — everything you need to hit the ground running abroad.",
            link: {
                href: "",
                text: "After-admit roadmap",
            },
        },
        {
            img: {
                src: "/Homepage_power profile.png",
                alt: "Profile Power Session. Sharpen your prep.",
                className: "feature-card_image left-align",
            },
            title: "Profile Power Session<br/> <i class='text-size-small'>Tests, LinkedIn, résumé, etc. to strengthen candidacy</i>",
            description: "Focused call with a mentor to audit your GMAT/GRE/SAT plan, rewire your LinkedIn and CV for admissions keywords, and hand you a step-by-step profile-upgrade roadmap. Walk away knowing exactly what to study, post, and polish — no guesswork.",
            link: {
                href: "",
                text: "Learn more",
                srText: "See all videos",
            },
        },
    ]
};

export const feature2Config = {
    title: "Career Studio by GradBrew — <br/>launching soon in 2027",
    description: `<strong>${siteSettings.siteName}’s mission doesn’t stop at admit — Career Studio picks up the baton</strong>.<br/><br/> Our upcoming <strong>Career Studio</strong> platform will support you through the next big phase: <strong>Internships, Career development, and Post-grad permanent roles</strong> — while you're at university.<br/><br/> From CVs and interview prep to exclusive job market insights, Career Studio will guide you toward success, long after you land on campus.<br/>`,
    note: "Note: It is an additional, post-admit premium service — not included in any school application consulting packages.",
    cta: {
        href: "/career-studio",
        text: "Join the Beta Waitlist",
        icon: (
            <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg"
                width="12" height="12" viewBox="0 0 12 12">
                <g fill="currentColor">
                    <path
                        d="M1.293,10.707a1,1,0,0,0,1.414,0L7.854,5.561l2.292,2.293A.5.5,0,0,0,10.5,8a.489.489,0,0,0,.191-.038A.5.5,0,0,0,11,7.5v-6a.5.5,0,0,0-.5-.5h-6a.5.5,0,0,0-.354.854L6.439,4.146,1.293,9.293A1,1,0,0,0,1.293,10.707Z"
                        fill="currentColor"></path>
                </g>
            </svg>
        ),
        subtext: "(Get early access, updates & bonus resources)"
    }
};

export const testimonialsConfig = {
    title: "What our customers say about us",
    subtitle: "Don’t just take our word for it - hear from those who’ve experienced the GradBrew difference.",
    testimonials: [
        {
            stars: 5,
            quote: "GradBrew sliced months off my prep, my engineer to consultant pivot jumped off the page.",
            author: {
                name: "MiM, INSEAD, France",
                image: "/Homepage_headerimg_Insead logo.webp"
            }
        },
        {
            stars: 5,
            quote: "Their dual-consultant edits turned my start-up failures into ‘entrepreneurial grit’. Booth loved it.",
            author: {
                name: "MBA, Chicago Booth, United States",
                image: "/Homepage_Chicago Booth Logo.jpeg"
            }
        },
        {
            stars: 4.5,
            quote: "Mock interviews felt harder than the real ones. That’s why UT Austin was a ‘YES’ in Round 1.",
            author: {
                name: "MFin, The University of Texas- Austin, United States",
                image: "/Homepage_UTexas Austin Logo.png"
            }
        },
        {
            stars: 5,
            quote: "From raw drafts to ISB-ready essays in 10 days. Zero ghostwriting, 100% my voice. ",
            author: {
                name: "PGP, Indian School of Business, India",
                image: "/Homepage_headerimg_ISB logo.png"
            }
        },
        {
            stars: 4.5,
            quote: "I was fresh out of undergrad and they framed my internships as leadership snapshots. LBS MiM, here I come!",
            author: {
                name: "Master in Management, London Business School, UK",
                image: "/Homepage_headerimg_LBS logo.jpg"
            }
        },
        {
            stars: 5.0,
            quote: "I thought my 8.8/10 GPA was ‘average’. GradBrew showed me how to sell the story. HEC, ESCP, ESSEC and EDHEC, all said 'Oui'.",
            author: {
                name: "Master in Management, HEC Paris",
                image: "/Homepage_headerimg_HEC_Paris logo.png"
            }
        },
    ]
};
export const homeAppsConfig = {
    headline: `Built to guide you from<br/> Dream to Admit and Beyond`,
    subheading: `Your GradBrew journey is designed to be complete — with real experts, AI-powered tools, and post-admit support that keep every stage ethical and effective`,
    homeAppList: [
        {
            name: "Dual Consultant Model",
            icon: (
                <img
                    loading="lazy"
                    alt="AI-Powered Ethical Application Tools"
                    className="home_apps_outlook-icon"
                    src="https://dummyimage.com/700x700/fff/aba"
                />
            ),
            heading: "Dual Consultant Model",
            description: (
                    `Two expert consultants. One perfected application.<br/>
                    You work closely with a mentor from your dream school and receive final-stage feedback from a second expert for a 360° view.`
            ),
            image: "/Homepage_Dual consultant model 2.png",
            imageAlt: "Dual Consultant Model",
            // button: null,
        },
        {
            name: "End-to-end Ethical Support",
            icon: (
                <img
                    loading="lazy"
                    alt="End-to-end Ethical Support"
                    className="home_apps_outlook-icon"
                    src="https://dummyimage.com/700x700/fff/aba"
                />
            ),
            heading: "End-to-end Ethical Support",
            description: "Craft your CV, SOP, LORs, and interview answers with our AI tools plus human insight.</br> You write your story; we help make it shine. No ghostwriting—just the authentic edge admissions officers trust.",
            image: "/Homepage_E2E Ethical Support 2.png",
            imageAlt: "End-to-end Ethical Support",
            // button: null,
        },
        {
            name: "Post-Admit Support",
            icon: (
                <img
                    loading="lazy"
                    alt="Microsoft Outlook icon"
                    className="home_apps_outlook-icon"
                    src="https://dummyimage.com/700x700/fff/aba"
                />
            ),
            heading: "Post-Admit Support",
            description: (
                    `Visa, housing, finances, arrival guidance, so you hit campus running. Next up?</br>Our soon-to-launch Career Studio platform takes over with on-campus internships, career coaching, and post-grad job leads while you’re still at school.`
            ),
            image: "/Homepage_post admit support 1.png",
            imageAlt: "Post-Admit Support",
            button: null,
        },
    ]
};

export const productConfig = {
    image: "/HomePage_GradBrew difference 2.png",
    sectionLabel: "Get admit-worthy conversations started",
    heading: `What makes ${siteSettings.siteName} truly different?`,
    paragraphs: [
        "While others push pre-written templates and ghostwriting,<br/> We pair <strong>real alumni mentors, AI-driven tools, and ethical guidance</strong> to bring out your best — truthfully, strategically, and with long-term impact.<br/><br/>",
        `${siteSettings.siteName} is NOT a ghostwriting service or a checklist shop.<br/>`,
        `We’re a <strong> strategic career enabler </strong>  that merges <strong> ethics, AI, top-school insights and elite mentorship.</strong> <br/>
      We shape you into the applicant and professional that top schools and top companies want to admit.`
    ],
    ctas: [
        { href: "/pricing?course=MIM&schools=4", text: "Pricing", className: "button w-button" },
        { href: "/profile-evaluation", text: "Free Profile Review", className: "button is-border w-button" }
    ]
};

export const benefitsConfig = {
    headline: `Choose Your Path — We’ll Guide the Journey`,
    subHeadline: `From high school seniors to experienced professionals, ${siteSettings.siteName} offers tailored support for every stage of your study abroad journey.`,
    image: `/Homepage_why Gradbrew.png`,
    benfitsList: [
        {
            icon: (
                <svg role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                    <title>Target icon</title>
                    <g className="icon-bg-2">
                        <path d="M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7Zm0,13a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"></path>
                        <circle cx="16" cy="16" r="2" className="icon-bg-1"></circle>
                        <path d="M16,0A16,16,0,1,0,32,16,16.047,16.047,0,0,0,16,0Zm0,27A11,11,0,1,1,27,16,11.013,11.013,0,0,1,16,27Z" className="icon-bg-1"></path>
                    </g>
                </svg>
            ),
            featuresList: [
                'Nail the “Why MBA” story—career leap, geo-switch, or fast-track growth',
                'Frame leadership wins and impact metrics to wow ad-coms',
                'School-style mock interviews, CV overhaul, and mentor-reviewed essays'
            ],
            link: {
                href: "/admissions-consulting/master-of-business-administration",
                text: "Explore MBA",
            },
            title: "Master of Business Administration (MBA)",
            description: <i>"For working professionals with 4 – 10 years’ experience"</i>,
        },
        {
            icon: (
                <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                    <title>Goal icon</title>
                    <g className="icon-bg-2">
                        <path className="icon-bg-1" d="M2,13C2,6.935,6.935,2,13,2c5.681,0,10.496,4.428,10.962,10.081l1.993-0.164C25.404,5.234,19.713,0,13,0 C5.832,0,0,5.832,0,13c0,6.713,5.235,12.403,11.917,12.956l0.165-1.994C6.429,23.495,2,18.68,2,13z"></path>
                        <path className="icon-bg-1" d="M13,7c2.967,0,5.521,2.211,5.939,5.143l1.979-0.283C20.36,7.949,16.956,5,13,5c-4.411,0-8,3.589-8,8 c0,3.955,2.948,7.359,6.857,7.919l0.283-1.98C9.21,18.52,7,15.966,7,13C7,9.691,9.691,7,13,7z"></path>
                        <path d="M31.707,25.293L26.414,20l3.293-3.293c0.269-0.269,0.362-0.667,0.24-1.027 s-0.438-0.621-0.815-0.671l-15-2c-0.31-0.041-0.62,0.064-0.839,0.284c-0.22,0.22-0.325,0.53-0.284,0.839l2,15 c0.05,0.378,0.31,0.693,0.67,0.815c0.359,0.121,0.759,0.028,1.028-0.24L20,26.414l5.293,5.293C25.488,31.902,25.744,32,26,32 s0.512-0.098,0.707-0.293l5-5C32.098,26.316,32.098,25.684,31.707,25.293z"></path>
                    </g>
                </svg>
            ),
            featuresList: [' Craft a standout story— no full-time experience required',
                'Spotlight academics, internships and global career vision',
                'Maximize your shot at multiple admits and scholarships'],
            title: "Master in Management (MiM)",
            link: {
                href: "/admissions-consulting/master-in-management",
                text: "Explore MiM",
            },
            description: <i>"For final-year students and fresh graduates with 0–3 years’ experience"</i>,
        },
        {
            icon: (
                <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                    <title>Integrations icon</title>
                    <g className="icon-bg-2">
                        <path d="M13,2H3A1,1,0,0,0,2,3V13a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V3A1,1,0,0,0,13,2Z" className="icon-bg-1"></path>
                        <path d="M31.7,7.293l-7-7a1,1,0,0,0-1.414,0l-7,7a1,1,0,0,0,0,1.414l7,7a1,1,0,0,0,1.414,0l7-7A1,1,0,0,0,31.7,7.293Z"></path>
                        <path d="M29,18H19a1,1,0,0,0-1,1V29a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V19A1,1,0,0,0,29,18Z" className="icon-bg-1"></path>
                        <path d="M13,18H3a1,1,0,0,0-1,1V29a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V19A1,1,0,0,0,13,18Z" className="icon-bg-1"></path>
                    </g>
                </svg>
            ),
            featuresList: ['Clear positioning for technical or industry-specific roles',
                'Domain-sharp storytelling & goals articulation',
                'Program-specific insights for top schools in US, EU, UK, etc.'],
            title: "Master in Finance (MFin), MFE or Specialized Masters",
            link: {
                href: "/admissions-consulting/master-in-finance",
                text: "Explore Specialized Masters",
            },
            description: <i>"For early professionals with 1 – 5 years' experience seeking niche tracks— Finance, Analytics, Marketing, Sustainability, etc."</i>,
        },
        {
            icon: (
                <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                    <title>Trust icon</title>
                    <g className="icon-bg-2">
                        <path className="icon-bg-1" d="M30,6c-3.991,0-9.751-2.063-13.4-4.8c-0.355-0.268-0.845-0.268-1.2,0C11.751,3.937,5.991,6,2,6 C1.448,6,1,6.447,1,7c0,10.728,5.733,20.116,14.606,23.919C15.732,30.973,15.866,31,16,31s0.268-0.027,0.394-0.081 C25.267,27.116,31,17.728,31,7C31,6.447,30.552,6,30,6z M16,28.907V16H4.54c-0.895-2.504-1.426-5.211-1.524-8.036 C7.116,7.686,12.303,5.803,16,3.233V16h11.46C25.389,21.792,21.341,26.48,16,28.907z"></path>
                    </g>
                </svg>
            ),
            featuresList: ['Country-specific strategy for US, UK, Canada, EU, etc.',
                'Essays, LORs, activities — plus SAT/ACT strategy that stands out',
                'End-to-end support on scholarships and deadline tracking'],
            title: "Undergraduate Admissions",
            link: {
                href: "/admissions-consulting/undergraduate-bachelors-abroad",
                text: "Explore Undergraduate",
            },
            description: <i>"For high-schoolers and parents mapping global options"</i>,
        },
    ]
};

export const HomeFaqsList = [
    {
        category: "",
        items: [
            {
                question: `1. How is ${siteSettings.siteName} different from traditional admission consultants?`,
                answer: (
                    <>
                        {siteSettings.siteName} blends structured mentorship with smart tools — all rooted in ethics. You’re guided by mentors from top schools, supported by AI where it helps, and always in charge of your own story. No ghostwriting, no shortcuts — just thoughtful strategy that works all within an ethical, transparent model. You’ll work with consultants who’ve actually been through the journey, not generic advisors.
                    </>
                ),
                answerText: `${siteSettings.siteName} blends structured mentorship with smart tools — all rooted in ethics. You're guided by mentors from top schools, supported by AI where it helps, and always in charge of your own story. No ghostwriting, no shortcuts — just thoughtful strategy that works within an ethical, transparent model. You'll work with consultants who've actually been through the journey, not generic advisors.`,
            },
            {
                question: `2. Who writes my application essays — me or ${siteSettings.siteName}?`,
                answer: (
                    <>
                        That’s core to our ethical promise. You share your story and prepare the first version using our guided prompts, AI-powered structure tools, and expert advice. Our mentors then step in with strategic feedback and review loops — so your final submission is stronger, sharper, and fully your voice.
                    </>
                ),
                answerText: "That's core to our ethical promise. You share your story and prepare the first version using our guided prompts, AI-powered structure tools, and expert advice. Our mentors then step in with strategic feedback and review loops — so your final submission is stronger, sharper, and fully your voice.",
            },
            {
                question: "3. What is the Dual Consultant model and how does it help?",
                answer: (
                    <>
                        You’ll work closely with a lead consultant from one of your target schools. Before submission, a second expert — also from a top school — steps in for a final review. It’s a smart way to get two perspectives on your story, so you submit with clarity and confidence.
                    </>
                ),
                answerText: "You'll work closely with a lead consultant from one of your target schools. Before submission, a second expert — also from a top school — steps in for a final review. It's a smart way to get two perspectives on your story, so you submit with clarity and confidence.",
            },
            {
                question: `4. Which programs and degrees does ${siteSettings.siteName} support?`,
                answer: (
                    <>
                        We support wide range of applications for Bachelor’s, MiM, MBA, MFin, MFE, Specialized Master’s, etc. Whether you're a high school student or a working professional, we match you with consultants who understand your path — and your goals.
                    </>
                ),
                answerText: "We support a wide range of applications for Bachelor's, MiM, MBA, MFin, MFE, Specialized Master's, and more. Whether you're a high school student or a working professional, we match you with consultants who understand your path — and your goals.",
            },
            {
                question: "5. Is the profile review really free? What can I expect from it?",
                answer: (
                    <>
                        Yes, it’s 100% free. You’ll get a school shortlist based on your profile, and you can optionally schedule a 15-minute call with one of our experts. It’s our way of helping you get clarity before making any commitment.
                    </>
                ),
                answerText: "Yes, it's 100% free. You'll get a school shortlist based on your profile, and you can optionally schedule a 15-minute call with one of our experts. It's our way of helping you get clarity before making any commitment.",
            },
            {
                question: "6. How is pricing structured — by school, package, or service?",
                answer: (
                    <>
                        You only pay for what you need. Our pricing depends on the type and number of schools you’re targeting — with flexibility to additional services later based on your plan.
                    </>
                ),
                answerText: "You only pay for what you need. Our pricing depends on the type and number of schools you're targeting — with the flexibility to add services later based on your plan.",
            },
            {
                question: "7. Do you offer refunds or flexible payment plans?",
                answer: (
                    <>
                        Yes, we offer flexible payment plans on select packages. Refunds are available within 14 days of purchase — provided no mentorship calls have been booked and no process has been initiated through your dashboard.<br /><br />
                        After this period, or once services begin, we don’t offer refunds — but you may be eligible for a deferral if your plans change. We’re also happy to support you with one additional school (at no cost) in the rare case of an application outcome mismatch, provided your school list was well-balanced and created with our guidance.<br /><br />
                        <a href="/legal/refund-policy" target="_blank" rel="noopener noreferrer">🔗 Read our full Refunds & Payment Policy</a>
                    </>
                ),
                answerText: "Yes, we offer flexible payment plans on select packages. Refunds are available within 14 days of purchase — provided no mentorship calls have been booked and no process has been initiated through your dashboard. After this period, or once services begin, we don't offer refunds — but you may be eligible for a deferral if your plans change. We're also happy to support you with one additional school (at no cost) in the rare case of an application outcome mismatch, provided your school list was well-balanced and created with our guidance.",
            },
            {
                question: `8. How does ${siteSettings.siteName} use AI in the application process?`,
                answer: (
                    <>
                        Our AI tools help you organize thoughts, build strong first drafts, and refine your writing. Mentors then bring in school-specific insights. At every step, you’re in control of what’s submitted.
                    </>
                ),
                answerText: "Our AI tools help you organize thoughts, build strong first drafts, and refine your writing. Mentors then bring in school-specific insights. At every step, you're in control of what's submitted.",
            },
            {
                question: "9. Will I receive tailored support or general templates?",
                answer: (
                    <>
                        Everything is personalized. From school shortlisting to essay feedback, your plan is designed around your background and target programs. We avoid templates because your story deserves better.
                    </>
                ),
                answerText: "Everything is personalized. From school shortlisting to essay feedback, your plan is designed around your background and target programs. We avoid templates because your story deserves better.",
            },
            {
                question: "10. Are there any discounts or scholarship opportunities?",
                answer: (
                    <>
                        Yes, though they’re selective and case-by-case. We offer referral credits, group discounts, and limited need-based concessions for high-potential candidates from economically weaker backgrounds. Every reduction is granted only after a quick profile review and remains subject to final management discretion.<br/><br/>
                        We try our best to make {siteSettings.siteName} accessible without compromising quality.
                    </>
                ),
                answerText: `Yes, though they're selective and case-by-case. We offer referral credits, group discounts, and limited need-based concessions for high-potential candidates from economically weaker backgrounds. Every reduction is granted only after a quick profile review and remains subject to final management discretion. We try our best to make ${siteSettings.siteName} accessible without compromising quality.`,
            },
            {
                question: `11. Which countries can I apply to with ${siteSettings.siteName}’s help?`,
                answer: (
                    <>
                        {siteSettings.siteName} supports admissions for every major study-abroad hub— the US, UK, Canada, continental Europe, Singapore, Australia, and other rising destinations.<br /><br />
                        Beyond shortlisting, we plug in country-specific insights— visa rules, job-market trends, tuition ROI— to be sure each school fits your goals, budget, and long-term career plan.
                    </>
                ),
                answerText: `${siteSettings.siteName} supports admissions for every major study-abroad hub — the US, UK, Canada, continental Europe, Singapore, Australia, and other rising destinations. Beyond shortlisting, we plug in country-specific insights — visa rules, job-market trends, tuition ROI — to be sure each school fits your goals, budget, and long-term career plan.`,
            },
        ],
    },

];
